import React from 'react';
import PropTypes from 'prop-types';
import { usePrefs, useLabels } from 'wsm-common-data';
import { CommonModal } from 'wsm-common-modal';
import IncentiveTrims from './IncentiveTrims';

const TrimsPopup = ({ isOpen, onClose, offer }) => {
	const prefs = usePrefs();
	const labels = useLabels();
	const modalTitle = labels.get('INCENTIVES_TRIMS_MODAL_TITLE');

	const modalPrefs = {
		...prefs,
		showIncentiveTrimsInOfferDetails: 'true'
	};

	return (
		<CommonModal
			isOpen={isOpen}
			title={modalTitle}
			onClose={onClose}
			width="responsive"
		>
			<IncentiveTrims offer={offer} overridePrefs={modalPrefs} />
		</CommonModal>
	);
};

TrimsPopup.propTypes = {
	isOpen: PropTypes.bool.isRequired,
	onClose: PropTypes.func.isRequired,
	offer: PropTypes.shape({
		trims: PropTypes.arrayOf(
			PropTypes.shape({
				year: PropTypes.number,
				make: PropTypes.string,
				model: PropTypes.string,
				bodyStyle: PropTypes.string,
				trim: PropTypes.string
			})
		)
	}).isRequired
};

export default TrimsPopup;
